module.exports = __webpack_public_path__ + "static/dream-big-47b64b2c012e49f9676da303c4b35130.jpg";